module.exports = __webpack_public_path__ + "static/media/icon-publish.dda3d46d.svg";